import { render, staticRenderFns } from "./MatchingRequestContext.vue?vue&type=template&id=72292b9c&scoped=true&"
import script from "./MatchingRequestContext.vue?vue&type=script&lang=ts&"
export * from "./MatchingRequestContext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72292b9c",
  null
  
)

export default component.exports